import { render, staticRenderFns } from "./EModalJustificarFalta.vue?vue&type=template&id=56e58909&scoped=true"
import script from "./EModalJustificarFalta.vue?vue&type=script&lang=js"
export * from "./EModalJustificarFalta.vue?vue&type=script&lang=js"
import style0 from "./EModalJustificarFalta.vue?vue&type=style&index=0&id=56e58909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e58909",
  null
  
)

export default component.exports